import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "envios-view" }
const _hoisted_2 = { class: "header-section" }
const _hoisted_3 = { class: "title-container" }

import { ref, computed, onMounted } from 'vue';
import { useEnviosStore } from '@/stores/useEnvioStore';
/* import IncidentActions from '@/components/incidents/IncidentActions.vue';
import IncidentFilters from '@/components/incidents/IncidentFilters.vue'; */
import EnvioListComponent from '@/components/envios/EnvioListComponent.vue';
import EnvioSearchComponent from '@/components/envios/EnvioSearchComponent.vue';
import EnvioFormComponent from '@/components/envios/EnvioFormComponent.vue';
/* import IncidentFormModal from '@/components/incidents/IncidentFormModal.vue'; */
import type { Envio } from '@/types/envioTypes';

import { Plus } from 'lucide-vue-next';

// Store

export default /*@__PURE__*/_defineComponent({
  __name: 'EnviosView',
  setup(__props) {

const enviosStore = useEnviosStore();

// State
const isFormModalOpen = ref(false);
const selectedEnvio = ref<Envio | null>(null);
/* const currentFilters = ref<IncidentFilters>({}); */

// Computed
const filteredEnvios = computed(() => {
  return enviosStore.envios.filter(envio => {
    // Lógica de filtrado según currentFilters
  });
});

// Handlers
const handleFormSubmit = async () => {
  await enviosStore.fetchEnvios();
}

const handleCloseModal = () => {
  isFormModalOpen.value = false;
};

const openCreateModal = () => {
  selectedEnvio.value = null;
  isFormModalOpen.value = true;
};

const openEditModal = (envio: Envio) => {
  selectedEnvio.value = envio;
  isFormModalOpen.value = true;
};
/* 
const handleFormSubmit = async (formData: IncidentForm) => {
  if (selectedIncident.value) {
    await incidentStore.updateIncident(formData);
  } else {
    await incidentStore.createIncident(formData);
  }
  isFormModalOpen.value = false;
}; */

const refreshEnvios = async () => {
  await enviosStore.fetchEnvios();
};

// Inicialización
onMounted(() => {
  enviosStore.fetchEnvios();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("h1", null, "Gestión de Envios", -1)),
        _createElementVNode("button", {
          class: "primary-button",
          onClick: openCreateModal
        }, [
          _createVNode(_unref(Plus)),
          _cache[0] || (_cache[0] = _createTextVNode(" Nuevo Envio "))
        ])
      ]),
      _createVNode(EnvioSearchComponent)
    ]),
    _createVNode(EnvioListComponent),
    _createVNode(EnvioFormComponent, {
      show: isFormModalOpen.value,
      onClose: handleCloseModal,
      onSubmit: handleFormSubmit
    }, null, 8, ["show"])
  ]))
}
}

})